@if (isOpen) {
  <div class="fixed inset-0 z-[70] flex items-end justify-center bg-black/60 p-3 md:items-center"
    (click)="closeModal(false)">
    <div class="w-full max-w-md rounded-2xl bg-white p-4 shadow-2xl" (click)="$event.stopPropagation()">
      <div class="mb-3 flex items-start justify-between">
        <h4 class="text-base font-semibold md:text-lg">
          {{ 'pwa.popup.title' | translate }}
        </h4>
        <button
          type="button"
          class="rounded-lg p-1.5 text-gray-400 hover:bg-gray-200 hover:text-gray-900"
          aria-label="Close"
          (click)="closeModal(false)">
          <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path clip-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              fill-rule="evenodd">
            </path>
          </svg>
        </button>
      </div>
      <div class="text-center text-sm md:text-base">
        {{ 'pwa.popup.text' | translate }}
      </div>
      <div class="mt-4 flex justify-end gap-2">
        <button type="button" class="rounded-full border border-gray-300 px-4 py-2 text-sm font-medium"
          (click)="closeModal(false)">
          {{ 'pwa.popup.later' | translate }}
        </button>
        <button type="button" class="custom-color rounded-full px-4 py-2 text-sm font-semibold text-white"
          (click)="install()">
          {{ 'pwa.popup.install' | translate }}
        </button>
      </div>
    </div>
  </div>
}
